export default "__VITE_ASSET__BTIPXmDb__"